<script>
import Base from '@backend/Base.vue';
import BOGen from '@helper/BOGen.js';
import BoConfig from '@config/BoConfig.js';
import Gen from '../helper/Gen';

export default {
  extends: Base,
  props:{
    parent: {default:()=>{ return {$route:{}}}},
    request: Boolean,
    iframe: Boolean,
    cf: {
      type: [Array, Object],
      default: () => ({})
    },
  },
  data(){
    return {
      Name: "WorkingFacility",
			PageName: "Working Facility Setup",
			ObjectName: "Working Facility",
      NoList: true,
      tabs: {id:1,activeService:""},
      mfsData: [],
      emp: {},
      fs: {},
      fsResp: [],
      oldFs: {},
      newFs: {},
      input: {},
      allFs: [],
      row: {aa:{},aal:{},haveJobtitle:false},
			mrAccessDoor: [],
			mrJobTitle: [],
			mrValidation:{
        cwid: "required|maxlength:5",
				ipin: "required",
				have_outstanding: "required",
        remarks: 'required'
			}
    }
  },
  computed:{
    aiStatus(){ return BoConfig.aiStatus },
    disableSetAF(){
      if(this.parent.$route.name=="AdditionalFacilityApproval") return true
      if(this.isServicesRole&&this.row.ai_type=='offboarding'&&this.row.ai_status!='SRF') return false
      return this.row.ai_status!='WFS' && !this.request
    },
    isFilled(){
      var fill = false
      this.workingFacilitiesActive().forEach(v=>{
        // if(this.row.ai_mwl_id==4&&v.mwf_id==7) return;
        if(v.active) fill = true
      })
      return fill
    },
    mrf_id(){
      return (this.parent.input||{}).mrf_id || this.row.ai_mrf_id
    },
    bulk_additional_facility(){
      return this.row.ai_type == 'additional-facility' && this.row.ai_root_group 
    },
    masterFacility(){
      if(this.row.ai_type == "additional-facility" && this.row.ai_mrf_id == 23){        
        return this.mfsData.filter(v => !v.mfs_is_lend)
      } else if(this.row.ai_type == "additional-facility" && (this.row.ai_mrf_id == 25)) {
        return this.mfsData.filter(v => v.mfs_is_lend)
      }else {
        return this.mfsData
      }
    }
  },
  mounted(){
		if(this.parent.Name){
      this.setParent()
    }else{
      if(!this.iframe) this.$set(this.$root, 'page', this)
      this.loadingOverlay = true
      this.refreshData()
    }
    if(this.isServicesRole){
      Object.keys(BoConfig.mrServicesRoleWF).forEach(k=>{
        if(this.isModule(k)){
          this.tabs.activeService = BoConfig.mrServicesRoleWF[k]
          this.tabs.id = BoConfig.mrServicesRoleWF[k]
        }
      })
    }
    setTimeout(() => {       
      this.checkLinkAuth()
     }, 1000)
	},
	methods:{
    setParent(){
      this.$set(this, 'emp', this.parent.emp)
      this.$set(this, 'mfsData', this.parent.mfsData)
      this.$set(this, 'row', this.parent.row)
      var fs = []
      if(this.request&&this.parent.newFs.length){
        fs = this.parent.newFs
      }else if(!this.request){
        fs = this.parent.fs
      }
      this.onRefreshPage(null, {fs:fs})
    },
    refreshData(){      
      BOGen.apirest("/"+this.Name+"/"+this.$route.params.id, {apc_id:this.$route.params.apc_id}, (err, resp)=>{
        this.loadingOverlay = false
        if(err) return this.$router.push({name:"Dashboard"})
        Object.keys(resp).forEach((k)=>{
          this[k] = resp[k]
        })
        if(this.$route.params.id){
          this.row.type = this.$route.params.id == "add" ? "add" : "update"
        }
        return this.onRefreshPage(err, resp)
      })
    },
    onRefreshPage(err, resp){
      this.loadingOverlay = false
      if(err) return this.$router.push({name:"Dashboard"})
      if(this.row.ai_type=="additional-facility"){
        this.row.ai_mwl_id = this.emp.mwl_id
        this.row.ai_mjt_id = this.emp.mjt_id
        this.row.division = this.emp.division
        this.row.department = this.emp.department
        this.row.worklocation = this.emp.worklocation
        this.row.costcenter = this.emp.costcenter
      }else{
        if(this.emp.mjt_id) this.row.ai_mjt_id = this.emp.mjt_id
      }
      if(this.row.ai_mjt_id) this.row.haveJobtitle = true
      this.oldFs = {}
      if(resp.fs.length) resp.fs.forEach(v=>{
        this.$set(this.oldFs, v.afs_mfs_id, v)
      })
      this.fsResp = resp.fs
      if(this.row.ai_type!="onboarding"){
        this.PageName = this.row.request_for+" Detail"
        if(this.row.ai_type=="additional-facility"&&["SRF","SPV","DONE","MNG","REJECTED"].indexOf(this.row.ai_status)>-1){
          this.fsResp = resp.newFs
        }
      
      }
      this.setFS();
      if(this.row.ai_mwl_id==4||this.emp.mwl_id==4){
        this.apiAccessDoor()
        this.apiJobTitle()
      }
      setTimeout(()=>{
        if(this.disableSetAF) $(this.$el).find(".card_working_facility").find("input,select,textarea").attr("disabled", true)
      }, 1000)
      
      if(this.request){
        if(this.parent.Name) this.$set(this.parent.input, 'fs', this.fs)
      }
      if(this.iframe){
        var page = this.$root.page
        if(page.onRefreshWF) page.onRefreshWF(this)
      }
      Object.keys(this.workingFacilities()).reverse().forEach(k=>{
        if(this.wfActive(k)) this.tabs.id = k
      })
      this.$emit("init", this)
    },
    setFS(){
      this.fs = {}
      if(this.fsResp) this.fsResp.forEach(v=>{
        this.$set(this.fs, v.afs_mfs_id, v)
      })
      this.mfsData.forEach((v)=>{
        var values = ""
        if(v.mfs_type=='checkbox') values = []
        if(v.mfs_type=='mobile_device') values = {brand:'',simcard:'micro'}
        if(v.mfs_type=='bit') values = false
        if(v.mfs_type=='sharefolder') values = [{access:'read'}]
        if(v.mfs_default) values = v.mfs_default
        if(!this.fs[v.mfs_id]) this.$set(this.fs, v.mfs_id, {
          afs_mfs_id:v.mfs_id,
          afs_answer:values,
          afs_remarks:"",
          afs_attachment: []
        })
      })
    },
		apiAccessDoor(){
			BOGen.apirest("/access-door-select", {}, (e,resp)=>{
				if(e) return console.error(e)
				this.mrAccessDoor = resp.data
			})
		},
		apiJobTitle(){
			BOGen.apirest("/job-title-select", {}, (e,resp)=>{
				if(e) return console.error(e)
				this.mrJobTitle = resp.data
			})
		},
    isHeading(v){
      if(this.heading==v.mfs_heading) return ""
      this.heading = v.mfs_heading
      return v.mfs_heading
    },
    isGroup(v){
      if(this.group==v.mfs_group) return ""
      this.group = v.mfs_group
      return v.mfs_group
    },
    wfActive(id){
      if(this.mrf_id==25){
        var show = false
        this.mfsData.filter(x=>{ return x.mfs_mwf_id == id }).forEach(v=>{
          if(this.isLend(v)) show = true
        })
        return show
      }
      if(this.$route.name == "StatusReportDetail") return true
      if(this.row.ai_status=="DONE"&&this.$route.name=="WorkingFacilityConfirmation"){
        return (this.workingFacilitiesActive().filter(v=>{return v.mwf_id==id})[0]||{}).active
      }
      if(this.row.ai_status=="CAF") return true
      if(!this.request&&this.isModule("HRServices")) return true
      if(["SRF"].indexOf(this.row.ai_status)>-1||
        (this.request&&this.mrf_id==24) ||
        (this.row.ai_type=="offboarding"&&this.isServicesRole)
      ){
        if(this.isModule(BoConfig.mrHRServices)) return id == 4
        return this.tabs.activeService == id
      }
      return true
    },
    isLend(v){
      if(this.mrf_id==25) return v.mfs_is_lend
      return true
    },
		workingFacilities(){
      var data = {}
      if(typeof this.mfsData == "undefined") return {}
			this.mfsData.forEach((v)=>{
				if(!data[v.mfs_mwf_id]) data[v.mfs_mwf_id] = v.mwf_name
			})
			return data
    },
    workingFacilitiesActive(){
      var data = []
      Object.keys(this.workingFacilities()).forEach(mwf_id=>{
        var active = false
        this.mfsData.filter(x=>{ return x.mfs_mwf_id == mwf_id }).forEach(v=>{
          if(typeof this.fs[v.mfs_id].afs_answer == "object"){            
            if(v.mfs_type == "checkbox"){
              if(this.fs[v.mfs_id].afs_answer.length) active = true
            }

            if(v.mfs_type == "checkbox_title"){
              if(this.fs[v.mfs_id].afs_answer.map(x => x.options).flat(Infinity).length) active = true
            }
          }
        })
        data.push({mwf_id:mwf_id,module:Gen.getKeyByValue(BoConfig.mrServicesRoleWF,mwf_id),active:active})
      })
      return data;
    },
    fsDiff(){
      return BOGen.fsDiff(this, this.oldFs, this.fs)
    },
		resultDataEmployee(data) {
			var items = [];
			data.data.forEach((x)=>{
				items.push({
					id: x.employeeno,
					text: (x.cwid?x.cwid+" | ":"")+x.employeename+" "+(x.position?"("+x.position+")":""),
				})
			})
			return {results: items}
		},
    addSharefolder(mfs_id){
      this.fs[mfs_id].afs_answer.push({access:'read'})
    },
    removeSharefolder(mfs_id, k){
      if(this.fs[mfs_id].afs_answer.length>1) this.fs[mfs_id].afs_answer.splice(k, 1)
    },
    sharefolderVal(list){
      if(typeof list != "object") return []
      list.forEach((v,k)=>{ if(!v.foldername) list.splice(k,1); })
      return list
    },
    submitForm(e){
      if(['DONE','REJECT'].indexOf(this.row.ai_status)>-1) return;
      swal({
        title: "Are you sure to submit?",
        text:"",
        icon: "warning",
        buttons: ["No, Cancel!", "Yes, Sure!"],
        // dangerMode: true,
      }).then((ok) => {
        if (!ok) return
        if(this.loadingOverlay) return;
        this.loadingOverlay = true

        if(this.row.ai_status=="CAF"){
          this.input.request_number = this.row.ai_request_number
          this.input.workingFacilitiesActive = this.workingFacilitiesActive()
          this.input.fsDiff = this.fsDiff()
          BOGen.apirest("/AdditionalFacilityConfirmation", this.input, (err, resp)=>{
            this.loadingOverlay = false
            if(err) return console.error(err)
            swal("Data has been submitted", "", "success").then(()=>{
              this.$router.push({name:"Inbox"})
              this.input = {}
              $("body,html").animate({scrollTop:0}, 300)
            })
          }, "POST")
        }else if(this.row.ai_status == "WFS"){
          var fs = [];
          Object.keys(this.fs).forEach(v=>{
            var afs = Gen.clone(this.fs[v])
            afs.afs_answer = JSON.stringify(afs.afs_answer)
            fs.push(afs)
          })
          var params = Gen.clone({
            ai_request_number: this.row.ai_request_number,
            fs: fs,
          });
          if(this.row.ai_mjt_id) params.ai_mjt_id = this.row.ai_mjt_id
          BOGen.apirest("/WorkingFacilitySetup", params, (err, resp)=>{
            this.loadingOverlay = false
            if(err){
              if(err.json.message) return Gen.info(err.json.message, "danger", 3000, ".infoRemarks")
              return console.error(err)
            }
            swal("Data has been submitted", "", "success").then(()=>{
              this.$router.push({name:"Inbox"})
            })
          }, "POST");
        }
        else if(this.isServicesRole&&this.row.ai_type=="offboarding"&&this.row.ai_wf_status=="OR"&&this.row.ai_status=="APA"){
          var fs = [];
          Object.keys(this.fs).forEach(v=>{
            var afs = Gen.clone(this.fs[v])
            afs.afs_answer = JSON.stringify(afs.afs_answer)
            fs.push(afs)
          })
          this.input.fs = fs
          BOGen.apirest("/ConfirmOutstanding", Gen.clone(Object.assign({
            request_number: this.row.ai_request_number,
          },this.input)), (err, resp)=>{
            this.loadingOverlay = false
            if(err){
              if(err.json.message) return Gen.info(err.json.message, "danger", 3000, ".infoRemarks")
              return console.error(err)
            }
            swal("Data has been submitted", "", "success").then(()=>{
              this.$router.push({name:"Inbox"})
            })
          }, "POST");
        }
        else if(this.isServicesRole&&this.row.ai_type=="offboarding"&&this.row.ai_wf_status=="OR"){
          var fs = [];
          Object.keys(this.fs).forEach(v=>{
            var afs = Gen.clone(this.fs[v])
            afs.afs_answer = JSON.stringify(afs.afs_answer)
            fs.push(afs)
          })
          this.input.fs = fs
          BOGen.apirest("/ConfirmOutstanding", Gen.clone(Object.assign({
            request_number: this.row.ai_request_number,
          },this.input)), (err, resp)=>{
            this.loadingOverlay = false
            if(err){
              if(err.json.message) return Gen.info(err.json.message, "danger", 3000, ".infoRemarks")
              return console.error(err)
            }
            swal("Data has been submitted", "", "success").then(()=>{
              this.$router.push({name:"Inbox"})
            })
          }, "POST");
        }else if(this.row.ai_status=="SPV"){
          this.input.workingFacilitiesActive = this.workingFacilitiesActive()
          var fs = [];
          Object.keys(this.fs).forEach(v=>{
            var afs = Gen.clone(this.fs[v])
            afs.afs_answer = JSON.stringify(afs.afs_answer)
            afs.afs_attachment = JSON.stringify(afs.afs_attachment||[]);
            fs.push(afs)
          })
          this.input.fs = fs
          BOGen.apirest("/RelatedWorkingFacility", Gen.clone(Object.assign({
            request_number: this.row.ai_request_number,
          },this.input)), (err, resp)=>{
            this.loadingOverlay = false
            if(err){
              if(err.json.message) return Gen.info(err.json.message, "danger", 3000, ".infoRemarks")
              return console.error(err)
            }
            swal("Data has been submitted", "", "success").then(()=>{
              this.$router.push({name:"Inbox"})
            })
          }, "POST");
        }
      });
    },
    afss(id){
      return this.row.afssGet.filter(v=>{ return BoConfig.mrServicesRoleWF[v.afss_type] == id })[0] || {}
    },
    afssOutstadingRemarks(id){
      if(id==4){
        var remarks = [];
        this.row.afssGet.filter(v=>{ return ["HRLeave","HRCB","HRSeparation"].indexOf(v.afss_type)>-1 }).forEach((v,k)=>{
          if(!v.afss_outstanding_remarks) return;
          var role = BoConfig.mrAccessModule[v.afss_type]
          remarks.push("<b>"+role+"</b> :<br>"+v.afss_outstanding_remarks)
        })
        return remarks.join("<br><br>")
      }
      return this.afss(id).afss_outstanding_remarks
    },
    checkLinkAuth(){
      if(this.row.ai_status == "SPV" && this.row.ai_created_by != this.user.cwid){
        return this.$router.push({ name: "Dashboard" })
      }
    }
	},
  watch:{
    '$route.query'(){
			this.refreshData()
    },
  }
}
</script>

<template>
	<div :class="{'container-fluid':!iframe&&!parent.Name}">
		<PageTitle v-if="!iframe&&!parent.Name"></PageTitle>

    <VForm @resp="submitForm" method="post">
		  <div class="card" v-if="!iframe&&!parent.Name">
        <div class="card-header bg-info">
          <h4 class="m-b-0 text-white">{{row.ai_type=='onboarding'?'Authorization':'Employee Information'}}</h4>
        </div>
        <div class="table-responsive">
          <table class="table table-striped m-b-0 tdl20">
            <tbody>
              <tr>
                <td><b>Request No</b>
                  <p><span class="label label-table label-success">{{row.ai_request_number}}</span></p>
                </td>
                <td><b>Request Date</b>
                  <p>{{ (row.ai_created_at||'').dates('format2') }}</p>
                </td>
                <td><b>Request For</b>
                  <p>{{ row.request_for }}</p>
                </td>
              </tr>
              <tr v-if="!bulk_additional_facility">
                <td><b>Employee Name</b>
                  <p>{{ row.employeename || emp.employeename || "-" }}</p>
                </td>
                <td><b>Employee No</b>
                  <p>{{ emp.employeeno || "-" }}</p>
                </td>
                <td><b>IPIN</b>
                  <p>{{ row.ai_ipin || emp.IPIN || "-" }}</p>
                </td>
              </tr>
              <tr v-if="!bulk_additional_facility">
                <td><b>Department</b>
                  <p>{{ row.ai_department || emp.department || "-" }}</p>
                </td>
                <td><b>Position</b>
                  <p>{{ emp.position || "-" }}</p>
                </td>
                <td><b>Cost Center SAP</b>
                  <p>{{ row.ai_costcenter || emp.costcenter || "-" }}</p>
                </td>
              </tr>
              <tr v-if="!bulk_additional_facility">
                <td colspan="2">
                  <template v-if="isModule('HROPS')">
                    <b>Position Title</b>
                    <p>{{ emp.jobtitle || "-" }}</p>
                  </template>
                </td>
              </tr>
              <tr v-if="row.aal.aal_remarks&&$route.name!='StatusReportDetail'">
                <td colspan="3"><b>Last Notes</b>
                  <p>{{ row.aal.aal_remarks }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
		  </div>
      <div class="card card_working_facility" :class="{iframe:iframe}" v-if="mfsData.length">
        <div class="card-body p-b-0" v-if="!iframe">
          <h4 class="card-title">Working Facility</h4>
        </div>
        <!-- Nav tabs -->
        <ul class="nav nav-tabs customtab" role="tablist">          
          <li class="nav-item" v-for="(v,k) in workingFacilities()" :key="k" v-show="wfActive(k)">
            <a class="nav-link" :class="{active:k==tabs.id}" data-toggle="tab" @click="tabs.id=k" href="javascript:;">
              <span>{{v}}</span>
            </a>
          </li>
        </ul>
        <!-- debug -->
        <section v-for="(mwf_name,mwf_id) in workingFacilities()" :key="mwf_id" v-show="tabs.id==mwf_id" :class="'wf_'+mwf_id">
          <template v-if="$route.name!='StatusReportDetail'">
          </template>
          <template v-for="(v,k) in masterFacility.filter(x=>{ return x.mfs_mwf_id == mwf_id })">
            <div :key="k" :class="'fs_'+v.mfs_type+' fs_'+v.mfs_id" v-if="isLend(v) && $route.name != 'OffboardingApproval'">
              <table class="table table-striped" v-if="isHeading(v)">
                <thead class="heading"><tr><th style="font-size:16px;">{{v.mfs_heading}}</th></tr></thead>
              </table>
              <div class="wrap_fs" v-if="isGroup(v)"><h5><b>{{v.mfs_group}}</b></h5></div>
              <div v-if="v.mfs_type=='checkbox'" class="wrap_fs">                
                <template v-if="$route.name != 'OffboardingApproval' && row.ai_type != 'offboarding'">                
                  <h5><b>{{v.mfs_name}}</b></h5>
                  <div class="row">
                    <div class="col-sm-4">
                      <Checkbox v-model="fs[v.mfs_id].afs_answer" :option="v2" :array="true" v-for="(v2,k2) in v.mfs_values" :key="k2">{{v2}}</Checkbox>
                    </div>
                    <div class="col-sm-6" v-if="v.mfs_with_remarks">
                      <textarea v-model="fs[v.mfs_id].afs_remarks" rows="3" class="form-control" placeholder="Remarks"></textarea>
                    </div>
                  </div>
                </template>
                <template v-else>
                    <div class="row">
                    <div class="col-md-7 mb-4">
                      <h5 class="mb-0"><strong>{{ v.mfs_name }}</strong></h5>
                      <div class="facilities" v-if="fs[v.mfs_id].afs_answer.length > 0">
                        <div class="facility-item mr-2" v-for="(item, k) in fs[v.mfs_id].afs_answer" :key="k">
                          <i class="icon-check"></i>
                          <span>{{ item }}</span>
                        </div>
                      </div>
                      <div class="facilities" v-else>
                        <p>No Items Selected</p>
                      </div>
                      <template v-if="v.mfs_with_remarks && v.mfs_with_remarks.length > 1">
                        <strong>Remarks</strong>
                        <p>{{ fs[v.mfs_id].afs_remarks }}</p>
                      </template>
                    </div>
                  </div>
                </template>
              </div>
              <div v-if="v.mfs_type=='checkbox_title'" class="wrap_fs">
                <hr>                
                <h5><b>{{v.mfs_name}}</b></h5>                
                <hr>
                <div class="row" v-for="(value, key) in v.mfs_values" :key="`parent-${key}`">
                  <template v-if="$route.name != 'OffboardingApproval' && row.ai_type != 'offboarding'">                
                    <div class="col-sm-12">
                      <h6 class="mb0 mt-2">{{ value.title }}</h6>
                    </div>
                    <hr>
                    <div class="col-sm-4">
                      <Checkbox 
                        v-model="fs[v.mfs_id].afs_answer" 
                        :option="{title: value.title, value: v2}" :array="true" 
                        :isArrayOfObjects="true" v-for="(v2,k2) in value.options" 
                        :key="k2"
                        :arrayOfObjects="v.mfs_values"
                      >{{v2}}</Checkbox>
                    </div>
                    <div class="col-sm-6" v-if="v.mfs_with_remarks && key == 0">
                      <textarea v-model="fs[v.mfs_id].afs_remarks" rows="3" class="form-control" placeholder="Remarks"></textarea>
                    </div>
                  </template>
                  <template v-else>                    
                    <div class="col-md-7 mb-4" v-if="fs[v.mfs_id].afs_answer">
                      <h6 class="mb-0" style="font-weight: 500;"><strong>{{ value.title }}</strong></h6>
                      <div class="facilities mr-2">                        
                        <template v-if="fs[v.mfs_id].afs_answer.find(x => x.title == value.title)">
                          <template v-if="fs[v.mfs_id].afs_answer.find(x => x.title == value.title).options">

                            <div class="facility-item" v-for="(x, k3) in fs[v.mfs_id].afs_answer.find(x => x.title == value.title).options" :key="k3">
                              <i class="icon-check"></i>
                              <span>{{ x }}</span>
                            </div>
                          </template>

                          <template v-else>
                            <p>No Items Selected</p>
                          </template>
                        </template>

                        <template v-else>
                          <p>No Items Selected</p>
                        </template>
                      </div>
                      <template v-if="v.mfs_with_remarks && v.mfs_with_remarks.length > 1">
                        <strong>Remarks</strong>
                        <p>{{ fs[v.mfs_id].afs_remarks }}</p>
                      </template>
                    </div>
                    <div class="col-md-7 mb-4" v-else>
                      <h6 class="mb-0" style="font-weight: 500;"><strong>{{ value.title }}</strong></h6>
                      <p>No Items Selected</p>
                    </div>
                  </template>
                </div>
              </div>
              <div v-if="v.mfs_type=='bit'" class="wrap_fs">
                <div class="row">
                  <div class="col-sm-3">
                    <Checkbox v-model="fs[v.mfs_id].afs_answer">{{v.mfs_name}}</Checkbox>
                  </div>
                  <div class="col-sm-6" v-if="v.mfs_with_remarks">
                    <textarea v-model="fs[v.mfs_id].afs_remarks" rows="2" class="form-control" placeholder="Remarks"></textarea>
                  </div>
                </div>
              </div>
              <div v-if="v.mfs_type=='textfield'" class="wrap_fs">
                <div class="row">
                  <div class="col-sm-3">{{v.mfs_name}}</div>
                  <div class="col-sm-6">
                    <input type="text" v-model="fs[v.mfs_id].afs_answer" class="form-control" :placeholder="v.mfs_name">
                  </div>
                </div>
              </div>
              <div v-if="v.mfs_type=='currency'" class="wrap_fs">
                <div class="row">
                  <div class="col-sm-3">{{v.mfs_name}}</div>
                  <div class="col-sm-6">
                    <div class="input-group">
                      <div class="input-group-prepend"><span class="input-group-text">IDR</span></div>
                      <Currency v-model="fs[v.mfs_id].afs_answer" class="form-control" :placeholder="v.mfs_name"></Currency>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="v.mfs_type=='dropdown'" class="wrap_fs">
                <div class="row">
                  <div class="col-sm-3">{{v.mfs_name}}</div>
                  <div class="col-sm-6">
                    <Select2 v-model="fs[v.mfs_id].afs_answer">
                      <option value="">-- Select One --</option>
                      <option v-for="(v2,k2) in v.mfs_values" :key="k2" :value="v2">{{v2}}</option>
                    </Select2>
                  </div>
                </div>
              </div>
              <div v-if="v.mfs_type=='sharefolder'" class="wrap_fs">
                <h5><b>{{v.mfs_name}}</b></h5>
                <div v-if="!disableSetAF">
                  <div v-for="(v2,k2) in fs[v.mfs_id].afs_answer" :key="k2" class="row">
                    <div class="col-sm-5">
                      <div class="form-group">
                        <input type="text" v-model="v2.foldername" class="form-control" placeholder="Folder Name">
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <Select2 url="/bussiness-group-select" v-model="v2.bg_id" :object="['mbg_bg_id','mbg_bussiness_group']">
                              <option value="">-- Select Division --</option>
                            </Select2>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="form-group">
                            <Select2 url="/work-location-select" :object="['mwl_id','mwl_name']" v-model="v2.mwl_id">
                              <option value="">-- Site --</option>
                            </Select2>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-8">
                          <div class="form-group">
                            <Select2 url="/department-select" :filter="'x.msg_bg_id=='+v2.bg_id" :object="['msg_id','msg_name']" v-model="v2.msg_id">
                              <option value="">-- Select Department --</option>
                            </Select2>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <Select2 :options="{read:'Read',write:'Write',full:'Full'}" v-model="v2.access"></Select2>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <Select2Ajax url="/api/employees-select" v-model="v2.owner" :resultData="resultDataEmployee" placeholder="-- Owner --"></Select2Ajax>
                      </div>
                      <div class="form-group">
                        <textarea v-model="v2.remarks" rows="3" class="form-control" placeholder="Remarks"></textarea>
                      </div>
                    </div>
                    <div class="col-sm-1">
                      <button type="button" v-tooltip="'Add'" @click="addSharefolder(v.mfs_id)" class="btn btn-success btn-sm btn-circle btn-block"><i class="fa fa-plus"></i></button>
                      <button type="button" v-tooltip="'Remove'" @click="removeSharefolder(v.mfs_id, k2)" class="btn btn-danger btn-sm btn-circle btn-block"><i class="fa fa-times"></i></button>
                    </div>
                    <div class="col-sm-12"><hr></div>
                  </div>
                </div>
                <div class="table-responsive table_sharefolder" v-if="disableSetAF">
                  <table class="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>Folder Name</th>
                        <th>Division</th>
                        <th>Site</th>
                        <th>Department</th>
                        <th>Access</th>
                        <th>Owner</th>
                        <th>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(v2,k2) in sharefolderVal(fs[v.mfs_id].afs_answer)" :key="k2">
                        <td>{{v2.foldername}}</td>
                        <td>
                          <Select2 url="/bussiness-group-select" v-model="v2.bg_id" :object="['mbg_bg_id','mbg_bussiness_group']"></Select2>
                        </td>
                        <td>
                          <Select2 url="/work-location-select" :object="['mwl_id','mwl_name']" v-model="v2.mwl_id"></Select2>
                        </td>
                        <td>
                          <Select2 url="/department-select" :object="['msg_id','msg_name']" v-model="v2.msg_id"></Select2>
                        </td>
                        <td>
                          <Select2 :options="{read:'Read',write:'Write',full:'Full'}" v-model="v2.access"></Select2>
                        </td>
                        <td>
                          <Select2Ajax url="/api/employees-select" v-model="v2.owner" :resultData="resultDataEmployee"></Select2Ajax>
                        </td>
                        <td>{{v2.remarks}}</td>
                      </tr>
                      <tr v-if="!sharefolderVal(fs[v.mfs_id].afs_answer).length">
                        <td colspan="8" class="tc">{{v.mfs_name}} is empty</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-if="v.mfs_type=='employee_info'" class="wrap_fs">
                <h5><b>{{v.mfs_name}}</b></h5>
                <table class="table table-striped m-b-0">
                  <tbody>
                    <tr>
                      <td width="34%"><b>CWID</b>
                        <p>{{emp.cwid||"-"}}</p>
                      </td>
                      <td width="34%"><b>Name</b>
                        <p>{{emp.employeename||'-'}}</p>
                      </td>
                      <td><b>Division</b>
                        <p>{{row.ai_division||emp.division||'-'}}</p>
                      </td>
                    </tr>
                    <tr>
                      <td><b>Supervisor</b>
                        <p>{{emp.supervisor.employeename||'-'}}</p>
                      </td>
                      <td><b>IPIN</b>
                        <p>{{emp.IPIN||"-"}}</p>
                      </td>
                      <td><b>Job Title</b>
                        <p>{{emp.jobtitle||"-"}}</p>
                      </td>
                    </tr>
                    <tr>
                      <td><b>Department</b>
                        <p>{{row.department||emp.department||"-"}}</p>
                      </td>
                      <td colspan="2"><b>Work Location</b>
                        <p>{{row.ai_worklocation||emp.worklocation||"-"}}</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="v.mfs_type=='mobile_device'" class="wrap_fs">
                <h5><b>{{v.mfs_name}}</b></h5>
                <div class="row form-group">
                  <div class="col-sm-2">Brand/Type</div>
                  <div class="col-sm-6">
                    <input type="text" v-model="fs[v.mfs_id].afs_answer.brand" class="form-control" placeholder="Brand/Type">
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-sm-2">Operating System</div>
                  <div class="col-sm-6">
                    <input type="text" v-model="fs[v.mfs_id].afs_answer.operating_system" class="form-control" placeholder="Operating System">
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-sm-2">Version</div>
                  <div class="col-sm-6">
                    <input type="text" v-model="fs[v.mfs_id].afs_answer.version" class="form-control" placeholder="Version">
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-sm-2">Memory</div>
                  <div class="col-sm-6">
                    <input type="text" v-model="fs[v.mfs_id].afs_answer.memory" class="form-control" placeholder="Memory">
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-sm-2">Date of Purchase</div>
                  <div class="col-sm-3">
                    <div class="input-group">
                      <DatePicker type="text" :config="{startDate:'-15y'}" v-model="fs[v.mfs_id].afs_answer.date_purchase" placeholder="Date of Purchase"></DatePicker>
                      <div class="input-group-append"><span class="input-group-text"><i class="icon-calender"></i></span></div>
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-sm-2">Sim-Card Type</div>
                  <div class="col-sm-6">
                    <Select2 :options="{micro:'Micro',nano:'Nano',mini:'Mini'}" v-model="fs[v.mfs_id].afs_answer.simcard"></Select2>
                  </div>
                </div>
                <Checkbox name="agree_mobile_device" v-model="fs[v.mfs_id].afs_answer.agreement" :attr="{required:fs[v.mfs_id].afs_answer.brand!=''}">Hereby declare to be willing to follow the rules prevailing in the company and BYOS policy attached.</Checkbox>
                <div><label error="agree_mobile_device" label="BYOS Policy"></label></div>
              </div>
              <div v-if="v.mfs_type=='access_door'" class="wrap_fs">
                <div class="row form-group">
                  <div class="col-sm-2">Job Title</div>
                  <div class="col-sm-4">
                    <Select2 v-model="row.ai_mjt_id" :options="mrJobTitle" :object="['mjt_id','mjt_name']" :disabled="row.haveJobtitle">
                      <option value="">-- Select Job Title --</option>
                    </Select2>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-sm-2">{{v.mfs_name}}</div>
                  <div class="col-sm-10">
                    <Checkbox v-model="fs[v.mfs_id].afs_answer" :option="v2.mad_id" :array="true" v-for="(v2,k2) in mrAccessDoor" :key="k2" style="width: 250px">{{v2.mad_name}}</Checkbox>
                  </div>
                </div>
              </div>
              <div v-if="v.mfs_type=='heading'" class="wrap_fs">
                <h4><b>{{v.mfs_name}}</b></h4>
              </div>
              <div v-if="v.mfs_type=='note'" class="wrap_fs">
                <p class="note">{{v.mfs_values}}</p>
              </div>
            </div>

            <template v-if="$route.name == 'OffboardingApproval'">
              <div v-if="v.mfs_type=='checkbox'" class="wrap_fs" :key="k+'w'">                              
                <div class="row">
                  <div class="col-md-7 mb-4">
                    <h5 class="mb-0"><strong>{{ v.mfs_name }}</strong></h5>
                    <div class="facilities" v-if="cf[v.mfs_id] && cf[v.mfs_id].afs_answer.length > 0">
                      <div class="facility-item mr-2" v-for="(item, k) in cf[v.mfs_id].afs_answer" :key="k">
                        <i class="icon-check"></i>
                        <span>{{ item }}</span>
                      </div>
                    </div>
                    <div class="facilities" v-else>
                      <p>No Items Selected</p>
                    </div>
                    <template v-if="v.mfs_with_remarks && v.mfs_with_remarks.length > 1">
                      <strong>Remarks</strong>
                      <p>{{ cf[v.mfs_id].afs_remarks }}</p>
                    </template>
                  </div>
                </div>
              </div>

              <div v-if="v.mfs_type=='checkbox_title'" class="wrap_fs" :key="k+'s'">                
                <h5><b>{{v.mfs_name}}</b></h5>
                <hr>

                <div class="row" v-for="(value, key) in v.mfs_values" :key="`parent-${key}`">                  
                  <template v-if="($route.name == 'OffboardingApproval')">
                    <div class="col-md-7 mb-4">
                      <h6 class="mb-0" style="font-weight: 500;"><strong>{{ value.title }}</strong></h6>
                      <div class="facilities mr-2">
                        <template v-if="cf[v.mfs_id] && cf[v.mfs_id].afs_answer.find(x => x.title == value.title)">
                          <template v-if="cf[v.mfs_id] && cf[v.mfs_id].afs_answer.find(x => x.title == value.title).options">

                            <div class="facility-item" v-for="(x, k3) in cf[v.mfs_id].afs_answer.find(x => x.title == value.title).options" :key="k3">
                              <i class="icon-check"></i>
                              <span>{{ x }}</span>
                            </div>
                          </template>

                          <template v-else>
                            <p>No Items Selected</p>
                          </template>
                        </template>

                        <template v-else>
                          <p>No Items Selected</p>
                        </template>                        
                      </div>
                      <template v-if="v.mfs_with_remarks && v.mfs_with_remarks.length > 1">
                        <strong>Remarks</strong>
                        <p>{{ cf[v.mfs_id].afs_remarks }}</p>
                      </template>

                    </div>
                  </template>
                </div>
              </div>
            </template>
          </template>
        </section>
		  </div>
      <!-- <div class="card" v-if="row.ai_status=='CAF'"> -->
      <div class="card" v-if="row.ai_status=='CAF' && row.ai_created_by==user.cwid">
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Remarks <small class="txt_mandatory">*</small></label>
                <textarea name="remarks" class="form-control" v-model="input.remarks" rows="5" required></textarea>
              </div>
            </div>
          </div>
          <div class="form-actions">
            <button type="submit" class="btn btn-info mr10" @click="input.status='A'">
              <span>Confirm that all facility is received</span>
            </button>
            <button type="submit" class="btn btn-danger" @click="input.status='R'">Reject</button>
          </div>
        </div>
      </div>
      <div class="card" v-else-if="!iframe&&!parent.Name&&['DONE','REJECT'].indexOf(this.row.ai_status)==-1&&$route.name!='StatusReportDetail'">
        <div class="card-body">
          <div class="row justify-content-end" v-if="isServicesRole && row.ai_type=='offboarding' && row.ai_status == 'APA'">
            <div class="form-actions">
              <button type="submit" class="btn btn-info btn-loading">
                <span>Confirm Facility Return</span>                
              </button>
            </div>
          </div>
          <div class="row" v-else-if="row.ai_type=='offboarding' && row.ai_status == 'SPV'">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header bg-info text-white">
                  <h5 class="card-title mb-0">Confirm Offboarding</h5>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-12">
                      <bo-field label="Is offboarding Finished?" mandatory>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input
                            type="radio"
                            id="confYes"
                            class="custom-control-input"
                            value="A"
                            v-model="input.status"
                            required
                          >
                          <label
                            class="custom-control-label"
                            for="confYes">Yes, Confirm Completion
                          </label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input
                            type="radio"
                            id="confNo"
                            class="custom-control-input"
                            value="R"
                            v-model="input.status"
                            required
                          >
                          <label
                            class="custom-control-label"
                            for="confNo">Not Finished Yet
                          </label>
                        </div>
                      </bo-field>
                    </div>
                    <div class="col-md-6" v-if="input.status">
                      <label>{{ input.status == 'A' ? 'Confirmation Notes' : 'Remarks' }}</label> <span class="text-danger">*</span>
                      <textarea name="remarks" class="form-control" v-model="input.remarks" rows="5" v-bind="validation('remarks')"></textarea>
                    </div>
                    <div class="col-12 text-right">
                      <button type="submit" class="btn btn-info" @click.prevent="submitForm" :disabled="!input.status || (input.status && !input.remarks)">Submit Confirmation</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>          
          <div class="row" v-else-if="row.ai_type=='additional-facility' && row.ai_status == 'SPV'">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title mb-0">Confirm Completion</h5>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-12">
                      <bo-field label="Have you received the facilities?">
                        <div class="custom-control custom-radio custom-control-inline">
                          <input
                            type="radio"
                            id="confYes"
                            class="custom-control-input"
                            value="A"
                            v-model="input.status"
                          >
                          <label
                            class="custom-control-label"
                            for="confYes">Yes, I have received
                          </label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input
                            type="radio"
                            id="confNo"
                            class="custom-control-input"
                            value="R"
                            v-model="input.status"                            
                          >
                          <label
                            class="custom-control-label"
                            for="confNo">I have not received
                          </label>
                        </div>
                      </bo-field>
                    </div>
                    <div class="col-md-6" v-if="input.status">
                      <bo-field :label="input.status == 'A' ? 'Confirmation Notes' : 'Remarks'" mandatory>
                        <textarea name="remarks" class="form-control" v-model="input.remarks" rows="5" required></textarea>
                      </bo-field>
                    </div>
                    <div class="col-12 text-right">
                      <button class="btn btn-info" type="submit" :disabled="!input.status">Submit Confirmation</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>        
      </div>
    </VForm>
	</div>
</template>